import React from 'react'
import PropTypes from 'prop-types'
import VisitLineItems from './VisitLineItems.js'
import { connect } from 'react-redux'

class VisitProducts extends React.Component {
  render = () => {
    const lineItems = this.props.lineItems.map(lineItem => <VisitLineItems key={lineItem.id} lineItem={lineItem} />)
    return (
      <React.Fragment>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className="panel-group">
          <div className="panel panel-success">
            <div className="panel-heading text-center">
              <a href="#product_orders" data-toggle="collapse">
                Παραγγελία Προϊόντων
              </a>
            </div>
            <div id="product_orders" className="panel-body panel-collapse collapse">
              <div className="table-responsive">
                <table className="table table-bordered table-striped table-fixed">
                  <thead>
                    <tr>
                      <th>Προϊόν</th>
                      <th className="text-center">&euro;</th>
                      <th className="text-center">Τμχ</th>
                      <th className="text-center">%</th>
                      <th className="text-center">Δώρο</th>
                      <th className="text-center">Απογ</th>
                      <th className="text-center">Τιμολ</th>
                    </tr>
                  </thead>
                  <tbody>{lineItems}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapState = state => {
  return {
    lineItems: state.lineItems,
    products: state.products
  }
}

const mapDispatch = dispatch => {
  return {
    addLineItem: () => dispatch({type: 'ADD_LINE_ITEM'})
  }
}

export default connect(mapState, mapDispatch)(VisitProducts)
